import {
  CartModel,
  CartModelJSON,
  CartItemModel,
  ProductDisplayIDModel,
} from '~/models'

const keyForCart = 'cartItems'

type Add2Cart = (item: CartItemModel) => void

export const addItem: Add2Cart = item => {
  const existing =
    window.localStorage.getItem(keyForCart)
  const cart =
    existing
      ? CartModel.fromJSON(JSON.parse(existing)) as CartModel
      : new CartModel({ items: [] })
  cart.add(item)
  window.localStorage.setItem(keyForCart, JSON.stringify(cart))
}

type ClearCart = () => void

export const clearCart: ClearCart = () => {
  const cart = new CartModel({ items: [] })
  window.localStorage.setItem(keyForCart, JSON.stringify(cart))
}

type GetCart = () => CartModel

export const getCart: GetCart = () => {
  const existing =
    window.localStorage.getItem(keyForCart)
  const cart =
    existing ? CartModel.fromJSON(JSON.parse(existing)) : new CartModel({ items: [] })
  return cart
}

type DeleteItem = (displayID: ProductDisplayIDModel) => void

export const deleteItem: DeleteItem = (displayID: ProductDisplayIDModel) => {
  const existing =
    window.localStorage.getItem(keyForCart)
  const cart =
    existing ? CartModel.fromJSON(JSON.parse(existing)) : new CartModel({ items: [] })
  cart.delete(displayID)
  window.localStorage.setItem(keyForCart, JSON.stringify(cart))
  return cart
}
